import React from 'react';
import PropTypes from 'prop-types';

const Phone = props => <span>{props.data.phone}</span>;

Phone.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Phone;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/phone.js